export default __webpack_public_path__ + "static/media/B_lopetus3.3f06eec1.mp3";